import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/residential',
    name: 'Residential',
    component: () => import('../views/Residential.vue')
  },
  {
    path: '/residential/:res',
    name: 'Residential Details',
    component: () => import('../views/ResidentialDetails.vue')
  },
  {
    path: '/commercial',
    name: 'Commercial',
    component: () => import('../views/Commercial.vue')
  },
  {
    path: '/commercial/:col',
    name: 'Commercial Details',
    component: () => import('../views/CommercialDetails.vue')
  },
  {
    path: '/booking',
    name: 'Booking',
    component: () => import('../views/Booking.vue')
  },
  {
    path: '/gallery-catalogue',
    name: 'Gallery',
    component: () => import('../views/Gallery.vue')
  },
  {
    path: '/gallery-catalogue/:id',
    name: 'Gallery Details',
    component: () => import('../views/GalleryDetails.vue')
  },
  {
    path: '/collaborators',
    name: 'Collaborators',
    component: () => import('../views/Collaborators.vue')
  },
  {
    path: '/collaborators/:col',
    name: 'Collaborators Details',
    component: () => import('../views/CollaboratorsDetails.vue')
  },
  {
    path: '/maps',
    name: 'Maps',
    component: () => import('../views/Maps.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  inkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes
})

export default router
